import React from 'react'
import "./App.scss";
import WelcomePage from '../WelcomePage/WelcomePage';
import ContentPage from '../ContentPage/ContentPage';

const App = () => {
    return (
        <div id="app">
            <div className="top-gradient"></div>
            <div className="bottom-gradient"></div>
            <WelcomePage />
            <ContentPage />

        </div>
    )
}

export default App
